import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntTargetIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.800003C4.0256 0.800003 0.800003 4.0256 0.800003 8C0.800003 11.9744 4.0256 15.2 8 15.2C11.9744 15.2 15.2 11.9744 15.2 8C15.2 4.0256 11.9744 0.800003 8 0.800003ZM8 2.24C11.1824 2.24 13.76 4.8176 13.76 7.99999C13.76 11.1824 11.1824 13.76 8 13.76C4.8176 13.76 2.24 11.1824 2.24 7.99999C2.24 4.8176 4.8176 2.24 8 2.24ZM3.68001 8C3.68001 5.6168 5.61681 3.68 8 3.68C10.3832 3.68 12.32 5.6168 12.32 8C12.32 10.3832 10.3832 12.32 8 12.32C5.61681 12.32 3.68001 10.3832 3.68001 8ZM8 5.12C9.5912 5.12 10.88 6.4088 10.88 8C10.88 9.5912 9.5912 10.88 8 10.88C6.4088 10.88 5.12 9.5912 5.12 8C5.12 6.4088 6.4088 5.12 8 5.12ZM6.56 8.00001C6.56 7.20801 7.208 6.56001 8 6.56001C8.792 6.56001 9.44 7.20801 9.44 8.00001C9.44 8.79201 8.792 9.44001 8 9.44001C7.208 9.44001 6.56 8.79201 6.56 8.00001Z"
      />
    </SntIcon>
  );
};

export default SntTargetIcon;
